import {FreeSpace} from "../types/Freespace";
import { convertFromRaw, EditorState } from "draft-js";

/**
   * マークアップの内容が存在するかチェック
   * @param content 
   * @returns 
   */
export const markupContentExist = (content: string) => {
    if(content) {
        const htmlContent = EditorState.createWithContent(convertFromRaw(JSON.parse(content)));
        return (htmlContent.getCurrentContent().hasText() && htmlContent.getCurrentContent().getPlainText().length > 0);
    }
    return false;
}

/**
 * OTS設定フリースペースPC用コンテンツチェック
 * @param freeSpace
 */
export const isAdminFreeSpacePC = (freeSpace: FreeSpace | undefined, lang: string) => {
    if (freeSpace === undefined) {
        return false;
    }

    if (lang === 'en') {
        if (freeSpace.adminFreeSpace?.content_en?.pc && markupContentExist(freeSpace.adminFreeSpace.content_en.pc)) {
            return true;
        }
    } else if (lang === 'ja') {
    
    if (freeSpace.adminFreeSpace?.content?.pc && markupContentExist(freeSpace.adminFreeSpace.content.pc)) {
      return true;
    }
  }
    if (freeSpace.okinawaSaihakkenFreeSpace?.content?.pc && markupContentExist(freeSpace.okinawaSaihakkenFreeSpace.content.pc)) {
        return true;
    }
    return false;
}

/**
 * OTS設定フリースペースSP用コンテンツチェック
 * @param freeSpace
 */
export const isAdminFreeSpaceSP = (freeSpace: FreeSpace | undefined, lang: string) => {
    if (freeSpace === undefined) {
        return false;
    }

    if (lang === 'en') {
        if (freeSpace.adminFreeSpace?.content_en?.sp && markupContentExist(freeSpace.adminFreeSpace.content_en.sp)) {
            return true;
        }
    } else if (lang === 'ja') {
      if (freeSpace.adminFreeSpace?.content?.sp && markupContentExist(freeSpace.adminFreeSpace.content.sp)) {
        return true;
      }
    }
    
    if (freeSpace.okinawaSaihakkenFreeSpace?.content?.sp && markupContentExist(freeSpace.okinawaSaihakkenFreeSpace.content.sp)) {
        return true;
    }
    return false;
}